import { useContext } from 'react';

import { ExportEventFormContext } from 'context/exportEventForm/exportEventFormContext/ExportEventFormContext';

export const useExportEventForm = () => {
  const context = useContext(ExportEventFormContext);

  if (context === undefined) {
    throw new Error('ExportEventFormContext is unavailable, make sure you are using ExportEventFormContextController');
  }

  return context;
};
